import { LESS_984_MEDIA_QUERY } from '../../../../../consts/adaptive';

const avatarStyle = {
    height: 45,
    width: 45,
    marginRight: 12,
    backgroundColor: '#9B9B9B',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxSizing: 'border-box'
};
export const styles = {
    avatar: {
        ...avatarStyle
    },
    defaultAvatar: {
        ...avatarStyle,
        padding: 6,
    },
    [LESS_984_MEDIA_QUERY]: {
        container: {
            height: 34,
            width: 34,

            '& > svg': {
                height: 22,
                width: 22,
            },
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
